import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DocumentCategoryDocumentTypeMatrix {

	static readonly egd00: string[] =['EGD000','EGD001','EGD002','EGD003','EGD004','EGD005','EGD006','EGD007','EGD008','EGD009','EGD010','EGD011','EGD012','EGD013','EGD014',
		'EGD015','EGD016','EGD017','EGD018','EGD019','EGD020','EGD021','EGD022','EGD023','EGD024','EGD000','EGD025','EGD026','EGD027','EGD028','EGD029',
		'EGD030','EGD031','EGD032','EGD033','EGD034','EGD037'];

	static readonly egd01: string[] = ['EGD000','EGD002','EGD006','EGD007','EGD008','EGD011','EGD013','EGD016','EGD018','EGD020','EGD022','EGD024','EGD028','EGD029','EGD031','EGD033',
		'EGD034','EGD037'];

	static readonly egd02: string[] = ['EGD000','EGD001','EGD012','EGD015','EGD016','EGD017','EGD019','EGD020','EGD025','EGD030','EGD032','EGD037'];

	static readonly egd03: string[] = ['EGD000','EGD002','EGD003','EGD004','EGD006','EGD007','EGD011','EGD016','EGD022','EGD031','EGD033','EGD034','EGD035','EGD036','EGD037'];

	static readonly egd04: string[] = ['EGD000','EGD003','EGD004','EGD005','EGD007','EGD008','EGD009','EGD010','EGD013','EGD016','EGD022','EGD024',
		'EGD027','EGD029','EGD031', 'EGD033', 'EGD037'];

	static readonly egd05: string[] = ['EGD000','EGD001','EGD002','EGD003','EGD004','EGD007','EGD008','EGD009','EGD010','EGD011','EGD016','EGD018',
		'EGD020','EGD024','EGD026', 'EGD029', 'EGD031', 'EGD033', 'EGD034', 'EGD037'];

	static readonly egd06: string[] = ['EGD000','EGD001','EGD002','EGD003','EGD004','EGD007','EGD008','EGD009','EGD010','EGD011', 'EGD013', 'EGD016',
		'EGD018','EGD020', 'EGD022', 'EGD024','EGD026', 'EGD027', 'EGD029','EGD030', 'EGD031', 'EGD033', 'EGD034', 'EGD037'];

	static readonly egd07: string[] = ['EGD000','EGD001','EGD002','EGD007','EGD008','EGD009','EGD010','EGD011','EGD016','EGD018','EGD020','EGD024',
		'EGD026', 'EGD029', 'EGD031', 'EGD033', 'EGD034', 'EGD037'];

	static readonly egd08: string[] = ['EGD000','EGD003','EGD004','EGD007','EGD008','EGD009','EGD010','EGD013','EGD016','EGD021','EGD022','EGD023','EGD024',
		'EGD025', 'EGD026', 'EGD029', 'EGD031', 'EGD033', 'EGD034', 'EGD037'];

	static readonly egd09: string[] = ['EGD000','EGD001','EGD002','EGD003','EGD005','EGD007','EGD008','EGD009','EGD010','EGD012','EGD013','EGD014',
		'EGD016','EGD018','EGD020','EGD022','EGD024','EGD025','EGD026','EGD028', 'EGD029', 'EGD030', 'EGD033', 'EGD034', 'EGD037', 'EGD038'];

	constructor() { }

	static getDocumentTypePossibilities(documentCategory: any) {
  	const categoryToDocumentTypeMap: { [key: string]: any } = {
  		'EGD00': this.egd00,
  		'EGD01': this.egd01,
  		'EGD02': this.egd02,
  		'EGD03': this.egd03,
  		'EGD04': this.egd04,
  		'EGD05': this.egd05,
  		'EGD06': this.egd06,
  		'EGD07': this.egd07,
  		'EGD08': this.egd08,
  		'EGD09': this.egd09,
  	};

  	return categoryToDocumentTypeMap[documentCategory] || [];
	}
}
